module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.toggle
      }),
      expression: "{methods:toggle}"
    }],
    staticClass: "course"
  }, [_c('span', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('div', {
    staticClass: "course-info"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.course.course_title))]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.course.created_at))])]), _vm._v(" "), _c('span', {
    staticClass: "absence"
  }, [_vm._v("缺勤" + _vm._s(_vm.course.absenteeism_count) + "人")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "users"
  }, [_c('ul', _vm._l((_vm.course.absence_user), function(user) {
    return _c('li', {
      key: user.id
    }, [_vm._v("\n        " + _vm._s(user.username) + "\n      ")])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48b8d45e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AttendanceItem.vue
// module id = 775
// module chunks = 1